export const environment = {
  credit_card_api_url: '',
  paper_gateway_url: 'https://api.stag-v2.paper.id',
  paper_mars_api_url: 'https://mars.stag-v2.paper.id/api/v1',
  send_new_relic: true,
  public_pem: `-----BEGIN PUBLIC KEY-----
    MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAo7DLUsrnKeDlcMb5L26x
    PLM7A56u53m+opGWZDaJsNxwql6sBnWtAEGgAjvWt91n7MWGdnRBRJd6LpfQw/XT
    GyW4qzTgMrEdvDlG6tNWyEHD8DIx95KVDsVgt1gt3yY77Qh+0TsmI2Hfqo8gS7G9
    gwwD5K7G+tp2aidu3ezbJmgWBiNm+TXnc7wN3AfbmL+OtPQdX4mUlmJoHGFCRWoC
    T62gxQnLMIxcP2FKETMqqqrs72BjikFBcCz3LGcfkA7mDaPTgbhecUCE81rcS5hQ
    u2Jaf5yo5iJ1joMbPYTT7g59+XuoJYmbF/CU9AhPQU+ij9lGS5uogDIH79wM9EaY
    1QIDAQAB
    -----END PUBLIC KEY-----`
};
